<template>
  <div class="footer">
    <div class="copyright">
      <div class="logo">
        <img :src="require('../assets/images/footer-logo.png')" alt />
        <div class="title">
          <p>上海交通大学</p>
          <p>励志讲坛</p>
        </div>
      </div>
      <div class="info">
        <p>沪公安网备 31009102000045</p>
        <a>http://lzjt.sjtu.edu.cn</a>
      </div>
    </div>
    <div class="menu">
      <div class="box" v-for="(itemMenu, index) in menu" :key="index">
        <p :class="item.className" v-for="(item, idx) in itemMenu" :key="idx">
          <router-link :to="item.link" v-if="item.link">{{
            item.title
          }}</router-link>
          <span v-else>{{ item.title }}</span>
        </p>
      </div>
    </div>
    <div class="qr-code">
      <div class="left">
        <img :src="require('../assets/images/qr-code-2.png')" alt />
        <p>微信公众号</p>
      </div>
      <div class="right">
        <img :src="require('../assets/images/qr-code1.png')" alt />
        <p>微博</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "../api";
import { HttpClient } from "../util/http";

export default {
  data() {
    return {
      menu: [
        [
          {
            title: "讲坛品牌",
            className: "h1",
            link: "",
          },
          {
            title: "励志讲坛",
            className: "",
            link: "/all-guest?type=brand&typeId=5cecaed34da6aa6314b13a9e",
          },
          {
            title: "励行讲堂",
            className: "",
            link: "/all-guest?type=brand&typeId=5ce9048dc955f935ad93e865",
          },
          {
            title: '"Voice-我思!"',
            className: "",
            link: "/all-guest?type=brand&typeId=5cebbf006f2de7575e4956cc",
          },
        ],
        [
          {
            title: "嘉宾类别",
            className: "h1",
            link: "",
          },
        ],
        [
          {
            title: "全部嘉宾",
            className: "h1",
            link: "/guest-details",
          },
          {
            title: "关于讲坛",
            className: "h1",
            link: "/about-pulpit",
          },
          {
            title: "联系我们",
            className: "h1",
            link: "/about-us",
          },
        ],
      ],
    };
  },
  created() {
    this.initState();
  },
  methods: {
    initState() {
      HttpClient.post(Api.learnType, {
        conds: {
          type: "category",
        },
      })
        .then((result) => {
          result.forEach((item) => {
            this.menu[1].push({
              link: `/all-guest?type=${item.type}&typeId=${item._id}`,
              title: item.name,
              className: "",
            });
          });
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="less" scoped>
@import "../theme.less";

.footer {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  p {
    color: @text-second;
  }
  .copyright {
    margin-top: 54px;
    .logo {
      display: flex;
      margin-bottom: 16px;
      img {
        height: 40px;
        margin-right: 8px;
      }
      .title {
        text-align: left;
        font-size: 13px;
        text-align: left;
        display: flex;
        flex-direction: column;

        justify-content: space-around;
        p {
          color: #fff;
        }
      }
    }
    .info {
      text-align: left;
      font-size: 12px;
      a {
        color: @text-second;
        text-decoration: underline;
        margin-top: 10px;
        display: block;
      }
    }
    p {
      margin: 0;
    }
  }
  .menu {
    width: 370px;
    margin-top: 80px;
    display: flex;
    justify-content: space-between;
    margin-right: 70px;
    .box {
      width: fit-content;
    }
    .h1 {
      color: #fff;
      font-size: 13px;
      a {
        color: #fff;
      }
    }
    p {
      font-size: 12px;
      a {
        color: @text-second;
      }
    }
  }
  .qr-code {
    margin-top: 80px;
    display: flex;
    justify-content: space-between;
    text-align: center;
    .left {
      margin-right: 23px;
    }
  }
}
</style>
